import { render, staticRenderFns } from "./sky-line.vue?vue&type=template&id=2bee0b08&scoped=true"
import script from "./sky-line.vue?vue&type=script&lang=js"
export * from "./sky-line.vue?vue&type=script&lang=js"
import style0 from "./sky-line.vue?vue&type=style&index=0&id=2bee0b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee0b08",
  null
  
)

export default component.exports